module.exports = __webpack_public_path__ + "img/senalando-izqpr.ebdcf9f4.png";